import React, {Component} from 'react'
import * as actionTypes from 'setup/redux/DattaThemeOptions'
import { Button, PageHeader, Badge } from 'antd';

import {connect} from 'react-redux'
import windowSize from 'react-window-size'
import { compact } from 'lodash';
import { GrChannel } from 'react-icons/gr';
import { IS_EVISION_VENDOR } from 'utils/convert';
import { ROLE_GENERAL } from 'utils/constants';

class NavLeft extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      location: '',
      titlePath: 'Quản lý kênh'
    }
  }

  componentDidMount() {
    this.setState({
      location: window.location.pathname
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (window.location.pathname !== prevProps.location.pathname) {
      this.setState({
        location: window.location.pathname
      });
    }
  }

  render() {
    const { location } = this.state;
    const { userCurrent } = this.props;
    const arrPathName = compact(location.split('/'));

    let activeButton = { borderRadius: '7px', backgroundColor: '#3f3f3f', color: 'white', border: 'none' };
    let activeRedButton = { borderRadius: '7px', backgroundColor: '#3f3f3f', color: 'white', border: 'none' };
    let inactiveButton = { borderRadius: '7px', borderWidth: '1px', backgroundColor: '#f3f3f3' };

    return <ul className='navbar-nav mr-auto ml-4' style={{ display: 'flex', alignItems: 'center' }}>
      {
        arrPathName.includes('accounts') ? (
          <>
            <PageHeader
              className='pl-0'
              title={this.state.titlePath}
            />
            <Button 
              className='mr-3'
              type='default'
              style={arrPathName.includes('general') ? { ...activeButton } : { ...inactiveButton }}
              onClick={() => {
                this.props.history.push(`/accounts/general`);
                this.setState({
                  titlePath: 'Quản lý kênh'
                });
              }}
            >Tổng quan</Button>
            <Button 
              type='default'
              className='mr-3'
              style={arrPathName.includes('videos-upload') ? { ...activeButton } : { ...inactiveButton }}
              onClick={() => { 
                this.props.history.push(`/accounts/videos-upload`);
                this.setState({
                  titlePath: 'Video tải lên'
                });
              }}
            >Video tải lên</Button>
            {
              IS_EVISION_VENDOR && [ROLE_GENERAL.SUPER_ADMIN].includes(userCurrent?.role) ? (
                <Button 
                  type='default'
                  className='mr-3'
                  style={arrPathName.includes('category-manage') ? { ...activeButton } : { ...inactiveButton }}
                  onClick={() => { 
                    this.props.history.push(`/accounts/category-manage`);
                    this.setState({
                      titlePath: 'Nhóm & Chủ đề'
                    });
                  }}
                >Nhóm & Chủ đề</Button>
              ) : null
            }
            <Button
              type='default'
              className='mr-3'
              style={
                arrPathName.includes('dead-channel') 
                  ? { ...activeRedButton, display: 'inline-flex' }
                  : { ...inactiveButton, display: 'inline-flex' }}
              onClick={() => {
                this.props.history.push(`/accounts/dead-channel`);
                this.setState({
                  titlePath: 'Kênh chết'
                });
              }}
            >
              <GrChannel fontSize={'15px'} className='mr-2' style={{ marginTop: '2px' }}/>
              Kênh chết
            </Button>
            <Badge dot color='green'>
              <Button 
                type='default'
                style={arrPathName.includes('ranking') 
                  ? { ...activeButton}
                  : { ...inactiveButton }}
                onClick={() => {
                  this.props.history.push(`/accounts/ranking`);
                  this.setState({
                  titlePath: 'Xếp hạng & Thống kê'
                });
                }}
              >Xếp hạng & Thống kê</Button>
            </Badge>
          </>
        ) : null
      }
      {
        location === '/dashboard' ? (
          <PageHeader
            className='pl-0 ml-0'
            title="Tổng quan"
          />
        ) : null
      }
      {
        location === '/proxies' ? (
          <PageHeader
            className='pl-0 ml-0'
            title="Quản lý Proxies"
          />
        ) : null
      }
      {
        location === '/setting' ? (
          <PageHeader
            className='pl-0 ml-0'
            title="Cài đặt thông số vận hành"
          />
        ) : null
      }
      {
        location === '/users' ? (
          <PageHeader
            className='pl-0 ml-0'
            title="Quản lý Thành viên"
          />
        ) : null
      }
    </ul>
  }
}


const mapStateToProps = (state) => {
  return {
    isFullScreen: state.DattaThemeOptions.isFullScreen,
    rtlLayout: state.DattaThemeOptions.rtlLayout,
    userCurrent: state?.auth?.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFullScreen: () => dispatch({type: actionTypes.FULL_SCREEN}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(windowSize(NavLeft))
